import {Model, ModelMixin} from '../common/model.class';
import {DateInfo} from './common/values/date-info.class';
import ProjectionInformation = Model.ProjectionInformation;

/**
 * Created by Rodrigo Quesada on 04/12/16.
 */
export class HealthStatus extends ModelMixin() implements Model<HealthStatus> {

    TYPE = HealthStatus;
    static projectionInformation = new ProjectionInformation('healthStatus');
    static adminProjectionInformation = new ProjectionInformation('healthStatusAdmin');

    substanceAbuseDependency: boolean;
    jobCompetencyIssues: boolean;
    unfamiliarFacilitiesIssues: boolean;
    details: string;
    tbPpdTest: DateInfo = new DateInfo();
    chestXRay: DateInfo = new DateInfo();
    fluShot: DateInfo = new DateInfo();
    titersTest: DateInfo = new DateInfo();
    tdap: DateInfo = new DateInfo();

    constructor(jsonData: any = {}) {
        super();
        if (jsonData.tbPpdTest) jsonData.tbPpdTest = new DateInfo(jsonData.tbPpdTest);
        if (jsonData.chestXRay) jsonData.chestXRay = new DateInfo(jsonData.chestXRay);
        if (jsonData.fluShot) jsonData.fluShot = new DateInfo(jsonData.fluShot);
        if (jsonData.titersTest) jsonData.titersTest = new DateInfo(jsonData.titersTest);
        if (jsonData.tdap) jsonData.tdap = new DateInfo(jsonData.tdap);
        Object.assign(this, jsonData);
    }

    askForDetails(): boolean {
        return this.substanceAbuseDependency
            || this.jobCompetencyIssues
            || this.unfamiliarFacilitiesIssues;
    }
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/@angularclass/hmr-loader!./~/tslint-loader!./src/app/domain/model/liability/health-status.model.ts